import React from "react";

import { Icon } from "semantic-ui-react";

import styles from "./DragHandle.css";

const DragHandle = () => {
	return (
		<div className={styles.dragHandle} data-draghandle="true">
			<Icon className={styles.dragHandleIcon}
				name="ellipsis vertical"
			/>
			<Icon className={styles.dragHandleIcon}
				name="ellipsis vertical"
			/>
		</div>
	);
};

export default DragHandle;
